module.exports = "<router-outlet></router-outlet>\r\n<ngx-loading-bar color=\"#FF9800\" [includeSpinner]=\"false\"></ngx-loading-bar>\r\n"